import { State } from '../reducers/types'

export const getAuthToken = (state: State): string | null => state.auth.authToken

export const getRefreshToken = (state: State): string | null => state.auth.refreshToken
